<template>
    <div class="container-fluid" v-if="Object.keys(promocode).length">
        <hr>
        <div class="row">
            <div class="col">
                <div class="form-group mb-1">
                    <label class="mb-0">{{ $t('Code') }}</label>
                    <p class="custom-gray-input-bg">{{ promocode.code }}</p>
                </div>
            </div>
            <div class="col">
                <div class="form-group mb-1">
                    <label class="mb-0">{{ $t('Discount') }} %</label>
                    <p class="custom-gray-input-bg">{{ promocode.discount_percent }}</p>
                </div>
            </div>
            <div class="col">
                <div class="form-group mb-1">
                    <label class="mb-0">{{ $t('Start') }}</label>
                    <p class="custom-gray-input-bg">{{ promocode.start_date | formatDate }}</p>
                </div>
            </div>
            <div class="col">
                <div class="form-group mb-1">
                    <label class="mb-0">{{ $t('End') }}</label>
                    <p class="custom-gray-input-bg">{{ promocode.end_date | formatDate }}</p>
                </div>
            </div>
        </div>
        <div v-if="contracts.length">
            <hr>
            <div class="row">
                <div class="col">
                    <h4>{{ $t('Use history') }}</h4>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="table-responsive">
                        <table class="table table-sm">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>{{ $t('Pick up & return') }}</th>
                                    <th>{{ $t('Price') }}</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(contract, i) in contracts" :key="i">
                                    <td>{{ i + 1}}</td>
                                    <td>
                                        {{ contract.pickup_location.name[locale] }} - {{ contract.return_location.name[locale] }}
                                        <br>
                                        {{ contract.start_time | formatDateTime }} - {{ contract.end_time | formatDateTime }}
                                    </td>
                                    <td>{{ contract.price }}</td>
                                    <td class="p-0">
                                        <div class="text-right">
                                            <router-link v-if="$store.getters.canViewContracts" :to="{name: 'contracts.show', params: {contract_id: contract.id}}" class="btn btn-info btn-sm text-white mt-2">
                                                {{ $t('View') }}
                                            </router-link>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PromocodeService from '@services/promocode.service';
import {mapGetters} from 'vuex';

export default {
    data() {
        return {
            promocode: {},
            contracts: []
        };
    },
    computed: {
        ...mapGetters(['locale'])
    },
    methods: {
        getPromocode(promocodeId) {
            PromocodeService.show(promocodeId).then(res => {
                this.promocode = res.promocode;
                this.contracts = res.contracts;
            });
        }
    },
    created() {
        this.getPromocode(this.$route.params.promocode_id);
    }
};
</script>
